import { LoadingSpinner, Text } from '@opengov/component-library/capital';
import React, { useState } from 'react';
import { useInterval } from 'use-interval';
import { IEditorMessages } from '../../../../types';
import styles from './LoadingText.scss';

type Props = {
  messages: IEditorMessages;
};

export function LoadingText({ messages }: Props): JSX.Element {
  const [index, setIndex] = useState(0);

  const loadingTexts = [
    messages.thisMayTakeAFewMoments,
    messages.wereStillWorkingOnIt,
    messages.holdOnTight,
    messages.almostThere
  ];

  useInterval(() => {
    setIndex((prevIndex) => (prevIndex + 1) % loadingTexts.length);
  }, 7500);

  return (
    <div className={styles.spinnerTextWrapper}>
      <LoadingSpinner variant="inline" className={styles.loadingSpinner} />
      <Text size="small" as="p" weight="bold" color="light">
        <em>{loadingTexts[index]}</em>
      </Text>
    </div>
  );
}
